var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import OnlineDiscountInstructions from './OnlineDiscounts';
import OnlineEmailSMSInstructions from './OnlineEmailSMS';
import OnlineMembershipButtonInstructions from './OnlineMembershipButton';
import OnlinePopupInstructions from './OnlinePopup';
import OnlineReceiptInstructions from './OnlineReceipt';
import OnlineRedirectInstructions from './OnlineRedirect';
import OnlineReplyInstructions from './OnlineReply';
const OnlineStoreInstructions = (_a) => {
    var { hasDiscounts } = _a, props = __rest(_a, ["hasDiscounts"]);
    return (_jsxs("div", { className: "online-store-instructions", children: [_jsx(OnlineReceiptInstructions, Object.assign({}, props)), hasDiscounts && _jsx(OnlineDiscountInstructions, Object.assign({}, props)), _jsx(OnlineReplyInstructions, Object.assign({}, props)), _jsx(OnlineRedirectInstructions, Object.assign({}, props)), _jsx(OnlineEmailSMSInstructions, Object.assign({}, props)), _jsx(OnlineMembershipButtonInstructions, Object.assign({}, props)), _jsx(OnlinePopupInstructions, Object.assign({}, props))] }));
};
export default OnlineStoreInstructions;
